import React from 'react';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../util/translationUtility';

class SearchDocuments extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
        };

    }

    render() {
        return (
            <div>
                <table className="table table-striped table-responsive">
                    <tr>
                        <th>{translateResourceString("/DocumentSearch/Results/Columns/ItemNumber")}{this.props.isCofADocument ? '*': ''}</th>
                        <th>{this.props.isCofADocument ? translateResourceString("/DocumentSearch/Results/Columns/LotNumber") : translateResourceString("/DocumentSearch/Results/Columns/Name")}</th>
                        <th>{translateResourceString("/DocumentSearch/Results/Columns/DocumentType")}</th>
                        <th>{translateResourceString("/DocumentSearch/Results/Columns/Language")}</th>
                    </tr>
                    {this.props.items.sort((a, b) => a.Name.localeCompare(b.Name) || a.Language.localeCompare(b.Language)).map((item) =>
                        <tr>
                            <td>{item.ErpItems.map((x) => 
                                <div>{x}</div>
                            )}</td>
                            <td><a className='link-neogen-teal' href={item.Link} target="_blank" dangerouslySetInnerHTML={{ __html: item.Name }} /></td>
                            <td>{item.Type}</td>
                            <td>{item.Language}</td>
                        </tr>
                    )}
                </table>
            </div>
        );
    }
}

SearchDocuments.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
};

export default SearchDocuments;